import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";
import {useDispatch } from 'react-redux'
import { addToCart } from '../redux/cartSlice'
function Products(props) {
  const dispatch = useDispatch();
    var[post,setPost]=useState([])
    useEffect(()=>{
      fetch(`https://fakestoreapi.com/products/category/${props.title}`)
      .then((res)=>res.json()).then((data)=>setPost(data));
    },[])
    return (
      <>
      <div className=' pb-4'>
      <div className='container'>
        <div className='row'>          
        {post.slice(0,4).map((a)=>(
           <div className='col-lg-3 col-sm-6 mb-sm-3'>
            <div className='card'>
              <img className='w-100 owl1' src={a.image}/>
              <div className='zoom'>
              <Link to='/' onClick={() => dispatch(addToCart(a))}><i class="bi bi-cart3 car add"></i></Link>
               
              <Link to={`/cat/${a.category}`}><i className="bi bi-shuffle pe-2 car add cate"></i></Link> 
              <Link to={`/details/${a.id}`}><i className="bi bi-zoom-in pe-2 car add det"></i></Link></div>            
              <div className='card-body'>
                 <p className='fw-bold '>{a.title}</p>
                 <p className='fw-bold pt-3'>Rs.{a.price}</p>
                 <span className="text-center d-flex py-3">
                    <p className='pe-2 text-decoration-line-through text-body-tertiary'>Rs.800</p>
                    <p>-5%</p>
                     </span>
                     <div className='star pb-3'>
                      <i class="bi bi-star-fill pe-2 text-warning"></i>
                      <i class="bi bi-star-fill pe-2 text-warning"></i>
                      <i class="bi bi-star-fill pe-2 text-warning"></i>
                      <i class="bi bi-star-fill text-body-tertiary pe-2"></i>
                      <i class="bi bi-star-fill text-body-tertiary"></i>
                      </div>
                 <button type="button" class="btn btn-dark" onClick={() => dispatch(addToCart(a))}>Add to Cart</button>
              </div>
            </div>
           </div>
           
          ))}
         </div>
       </div>
      </div>
      </>
    )
  }

export default Products
